import React from 'react'
import { AppBar, AppContextProvider } from '@ampcore/design-system'
import PropTypes from 'prop-types'

export const CampaignHeader = props => {
  const {
    stickyHeader,
    primaryButtonUrl,
    primaryButtonTarget,
    primaryButtonAnalyticsName,
    primaryButtonLabel,
    campaignNewPrimaryButtonLabel,
    campaignNewPrimaryButtonUrl,
    campaignNewPrimaryButtonTarget,
    campaignNewPrimaryButtonAnalyticsName
  } = props

  let links = []
  if (campaignNewPrimaryButtonLabel && campaignNewPrimaryButtonUrl) {
    links = [
      {
        variant: 'primary',
        name: campaignNewPrimaryButtonLabel,
        url: campaignNewPrimaryButtonUrl,
        target: campaignNewPrimaryButtonTarget,
        analyticsName: campaignNewPrimaryButtonAnalyticsName
      }
    ]
  } else if (primaryButtonLabel && primaryButtonUrl) {
    links = [
      {
        variant: 'primary',
        name: primaryButtonLabel,
        url: primaryButtonUrl,
        target: primaryButtonTarget,
        analyticsName: primaryButtonAnalyticsName
      }
    ]
  }

  return (
    <AppContextProvider isMenuFetchDisabled={true}>
      <AppBar
        logoHref="/"
        variant="campaign-page"
        analyticsName="Header"
        mobileBottomNavItems={[
          {
            title: 'Customer Service',
            url: '/customer-service',
            dataAnalytics: 'Customer Service'
          },
          {
            title: 'Online security guarantee',
            url: '/privacy-security-fraud/online-security-guarantee',
            dataAnalytics: 'Online security guarantee'
          }
        ]}
        links={links}
        stickyHeader={stickyHeader === 'true'}
      />
    </AppContextProvider>
  )
}

CampaignHeader.propTypes = {
  stickyHeader: PropTypes.string,
  primaryButtonUrl: PropTypes.string,
  primaryButtonTarget: PropTypes.string,
  primaryButtonAnalyticsName: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  campaignNewPrimaryButtonLabel: PropTypes.string,
  campaignNewPrimaryButtonUrl: PropTypes.string,
  campaignNewPrimaryButtonTarget: PropTypes.string,
  campaignNewPrimaryButtonAnalyticsName: PropTypes.string
}

export default CampaignHeader
